import React, { useState, useCallback } from "react";
import CustomTable from "@/components/common/table/CustomTable";
import { useDispatch } from "react-redux";
import { AppThunkDispatch } from "@/store";
import actionsHandler from "@/store/actions/actionHandler";
import EyeIcon from "@styles/all-images/icons/view-icon.svg";
import dateHandler from "@/composables/dateUtil";
import StatusChips, {
  StatusChipEnumType,
} from "@/components/common/StatusChips";
import { useNavigate } from "react-router-dom";

interface TermSheetTableT4Props {
  tabId: number;
}

const TermSheetTableT4: React.FC<TermSheetTableT4Props> = ({ tabId }) => {
  const dispatch = useDispatch<AppThunkDispatch>();
  const { formatDate } = dateHandler();
  const [forceReset, setForceReset] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);

  const navigate = useNavigate();

  const handleView = useCallback((doc: any) => {
    navigate(`/view-im-ts-document/${doc.id}?type=ts&history=false`);
  }, []);

  const columns = [
    {
      header: "Document Name",
      accessor: "document_name",
      sortable: true,
      sortKey: "document_name",
    },
    {
      header: "Received Date & TIme",
      accessor: (row: any) => formatDate(row.uploaded_on),
      sortable: true,
      sortKey: "uploaded_on",
    },
    {
      header: "Sent By",
      accessor: "sent_by",
      sortable: true,
      sortKey: "sent_by",
    },
    {
      header: "Status",
      accessor: (row: any) => (
        <StatusChips
          status={row.approval_status}
          type={StatusChipEnumType.IMTSDocumentApproval}
          showRejectionNote={true}
          rejectionNote={row.note}
        />
      ),
      sortable: true,
      sortKey: "approval_status",
    },
    {
      header: "Action",
      accessor: (row: any) => (
        <div className="tw-flex tw-items-center">
          <button onClick={() => handleView(row)} title="View">
            <img
              src={EyeIcon}
              alt="View"
              className="tw-w-10 tw-h-10 tw-max-w-10 tw-max-h-10 tw-min-w-10 tw-min-h-10"
            />
          </button>
        </div>
      ),
    },
  ];

  const fetchDocumentsWrapper = useCallback(
    async (params: any) => {
      try {
        const { authenticatedCall } = actionsHandler("termSheetListT4");

        const queryParams = new URLSearchParams({
          limit: params.limit || 10,
          page: params.page || 1,
          search: params.search || "",
          ...(params.sortColumn && {
            ordering:
              (params.sortDirection === "desc" ? "-" : "") + params.sortColumn,
          }),
        }).toString();

        const response = await dispatch(
          authenticatedCall({
            method: "get",
            customQuery: queryParams,
          }),
        );

        return response;
      } catch (error) {
        console.error("Error fetching term sheet documents:", error);
        return {
          data: {
            data: [],
            meta: { count: 0, page: 1, total_pages: 1, limit: 10 },
          },
        };
      }
    },
    [dispatch],
  );

  return (
    <>
      <CustomTable
        columns={columns}
        fetchData={fetchDocumentsWrapper}
        forceRefresh={forceRefresh}
        setForceRefresh={setForceRefresh}
        forceReset={forceReset}
        setForceReset={setForceReset}
        noDataMessage="No term sheet documents found"
        noSearchDataMessage="No matching term sheet documents found"
      />
    </>
  );
};

export default TermSheetTableT4;
